export default __webpack_public_path__ + "static/media/hacker.7a6b5b02.png";